import React, { useContext, useEffect } from 'react';
import useOnChange from '../../../../hooks/useChange';
import { ContextBuilder } from "../../../../context/builder/reducers";
import arrayMove from 'array-move';
import SortableList, { SLIDER_IMAGE_ITEM } from '../SortableList';

const ItemList = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);

    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {
                elements: []
            }
            dispatch({ type: 'data', payload: { data } })
        }
    });

    let elements = props.content.elements || [];

    const addItem = () => {
        const data = state.data;
        elements = [...elements, { text: '', img: '', title: '' }];
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const data = state.data;
        elements = arrayMove(elements, oldIndex, newIndex);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const deleteButtonHandler = (e) => {
        const index = e.currentTarget.getAttribute('index');
        const data = state.data;
        elements.splice(index, 1);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    return (
        <SortableList
            item={SLIDER_IMAGE_ITEM}
            titleComponent="Slider image"
            type={props.type}
            elements={elements}
            onChange={onChange}
            onSortEnd={onSortEnd}
            addItem={addItem}
            deleteButtonHandler={deleteButtonHandler}
            axis="xy"
            useDragHandle
        />);
}

export default ItemList;
